import { Injectable, inject } from '@angular/core';
import { OperationsCatalogService } from '../services/operations-catalog.service';
import { TenantService } from '../tenant/tenant.service';
import type {
  CardApiContract,
  CompanyApiContract,
  ProjectApiContract,
  WorkflowApiContract,
  WorkflowStageApiContract,
} from './contracts/operations.contract';

@Injectable({ providedIn: 'root' })
export class OperationsMockApiService {
  private readonly tenant = inject(TenantService);
  private readonly catalog = inject(OperationsCatalogService);

  getCompany(): CompanyApiContract | null {
    const activeCompany = this.tenant.activeCompany();
    const fallbackCompany = this.tenant.companies()[0] ?? null;
    const company = activeCompany ?? fallbackCompany;
    if (!company) return null;

    return {
      id: company.id,
      name: company.name,
      logoUrl: company.logoUrl ?? null,
    };
  }

  getProjects(): ProjectApiContract[] {
    return this.catalog.projects().map((project) => ({
      id: project.id,
      name: project.name,
      description: project.description ?? null,
      coverImageUrl: project.coverImageUrl ?? null,
      iconKey: 'folder',
      colorHex: '#3B82F6',
    }));
  }

  getWorkflows(): WorkflowApiContract[] {
    return this.catalog.workflows().map((workflow) => ({
      id: workflow.id,
      projectId: workflow.projectId,
      name: workflow.name,
      iconKey: workflow.iconKey,
      colorHex: workflow.colorHex,
      description: workflow.description ?? null,
      defaultDueInDays: workflow.defaultDueInDays,
      isAccessRestricted: workflow.isAccessRestricted,
      stages: workflow.stages.map((stage): WorkflowStageApiContract => ({
        id: stage.id,
        name: stage.name,
        order: stage.order,
        colorHex: stage.colorHex,
      })),
    }));
  }

  getCards(): CardApiContract[] {
    return this.catalog.cards().map((card) => ({
      id: card.id,
      projectId: card.projectId,
      workflowId: card.workflowId,
      workflowStageId: card.workflowStageId,
      code: null,
      title: card.title,
      ownerName: card.ownerName,
      priority: 'Média',
      dueDate: card.dueDate,
      commentsCount: card.commentsCount,
      attachmentsCount: card.attachmentsCount,
      checklistDone: card.checklistDone,
      checklistTotal: card.checklistTotal,
      quickFields: [],
      fieldValues: {},
    }));
  }
}
